import { List, Edit, Create } from "../Components/index.js";

export default [
    {
        path: "/vehicle/list",
        component: List,
        name: "vehicle-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/vehicle/:id/edit",
        component: Edit,
        name: "vehicle-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/vehicle/create",
        component: Create,
        name: "vehicle-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/vehicle/barcode",
        component: () => import("../Components/Barcode.vue"),
        name: "vehicle-barcode",
        meta: {
            requiresAuth: true,
        },
    },
];
